import { Injectable } from '@angular/core';

import {map, Observable, Subject } from 'rxjs';

import { RouteListFilterRequest } from '../../models/remote.request/RouteListFilterRequest';
import { RouteEventPoint } from '../../models/domain/RouteEventPoint';
import { RouteEvent } from '../../models/domain/RouteEvent';

import { IRouteService } from '../../interfaces/IRouteService';
import { WebAccessService } from '../web.access/web-access.service';
import { RouteStats } from '../../models/domain/RouteStats';

@Injectable()
export class RouteService implements IRouteService {

	public pointUpdateRequired: Subject<RouteEventPoint> = new Subject<RouteEventPoint>();

	getRouteForDate$(from: Date, to: Date, vehicleId: number, GetDriverAndNotes?: boolean): Observable<RouteEvent[]> {
		const request: RouteListFilterRequest = {
			DateFrom: from,
			DateTo: to,
			VehicleId: vehicleId,
			GetDriverAndNotes,
		};
		return this.$webAccess.GetRouteListByFilter(request).pipe(map(x => x.Result as RouteEvent[]));
	}

	getRouteStats$(vehicleId: number, startDate: Date, endDate: Date): Observable<RouteStats> {
		const request: RouteListFilterRequest = {
			DateFrom: startDate,
			DateTo: endDate,
			VehicleId: vehicleId
		};
		return this.$webAccess.GetRouteStatsByFilter(request).pipe(map(x => x.Result as RouteStats));
	}

	getRouteAvailableDates$(vehicleId: number, year: number, month: number): Observable<Date[]> {
		return this.$webAccess.GetRouteAvailableDates(vehicleId, year, month).pipe(map(x => x.Result as Date[]));
	}

	constructor(
		private $webAccess: WebAccessService
	) { }
}
